var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notice-scroll-container"},[_c('div',{staticClass:"notice-scroll-wrapper"},[_c('div',{staticClass:"notice-scroll-content"},[_c('span',{staticClass:"notice-item"},[_vm._t("default")],2),_c('span',{staticClass:"notice-item"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }